import is, { isNot } from 'typescript-styled-is'
import styled, { ITheme, keyframes } from '../../../theme'

const showArrows = keyframes`
  from {
    opacity: 0;
    font-size: 0em;
  }

  to {
    opacity: 0.5;
    font-size: .875em;
  }
`

const expandArrow = keyframes`
  from {
    opacity: 0.5;
    font-size: .875em;
  }

  to {
    opacity: 1;
    font-size: 1.0em;
  }
`

const expandDayBcgr = keyframes`
  from {
    width: 0.8em;
    height: 0.8em;
  }
  to {
    width: 1.75em;
    height: 1.75em;
  }
`

export const WeekDays = styled.ul`
  margin: 0px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  list-style-type: none;
  padding: 0 1em;
`

export const DayOfWeek = styled.div`
  font-size: 0.375em;
  position: absolute;
  left: 0;
  width: 100%;
  line-height: 0;
  color: ${(props: ITheme) => props.theme.colors.palette.emerald};
`

export const SelectedDayBackground = styled.div`
  position: absolute;
  z-index: 1;
  border-radius: 32px;
  background-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
  top: 50%;
  box-shadow: 0 0 32px rgba(0, 0, 0, 0.1);
  left: 50%;
  transform: translate(-50%, -50%);
  animation: ${expandDayBcgr} 0.2s ease forwards;
`

export const Picker = styled.div<IPicker>`
  ${isNot('days')`
    display: flex;
    justify-content: center;
    align-items: center;
  `};

  position: relative;
  width: 100%;
  height: 60px;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  line-height: 60px;
  font-size: 1.5em;
  font-weight: 600;
  &:hover a {
    animation: ${showArrows} 0.2s linear forwards;
  }
  & > a:hover {
    animation: ${expandArrow} 0.2s linear forwards;
  }
`

export interface IPicker {
  days?: boolean
}

export const Controls = styled.div`
  margin: -1px;
  position: relative;
  z-index: 2;
  height: 56px;
  overflow: hidden;
`

export const DaysPicker = styled.div`
  width: 100%;
  height: 244px;
`

export const Days = styled.ul`
  padding: 0.875em;
  margin: 0px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  list-style-type: none;
  li:hover {
    text-decoration: underline;
  }
`

export const Date = styled.a``

export const Day = styled.li<IDayProps>`
  position: relative;
  display: list-item;
  float: left;
  text-align: center;
  width: 14.285714286%;
  line-height: 36px;
  height: 36px;
  font-size: 0.875em;
  cursor: pointer;
  a {
    position: relative;
    z-index: 2;
  }
  ${is('weekend')`
    color: ${(props: ITheme) => props.theme.colors.primary};
  `}
  ${is('selected')`
    font-size: 1.5em;
    color: #fff;
  `}
  ${is('isSelected')`
    color: #fff;
  `}
  ${is('inactive')`
    opacity: 0.4;
    text-decoration: none !important;
  `}
  ${is('sized')`
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    display: block;
    line-height: 1.5em;
    font-size: 2em;
    font-weight: 600;
   `}
`

export const SubmitButton = styled.div`
  margin: 0 auto;
  width: 56px;
  height: 56px;
  line-height: 64px;
  border-radius: 56px;
  font-size: 2em;
  cursor: pointer;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  text-align: center;
  position: relative;
  top: 0;
  color: #fff;
  background-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
  transition: top 0.2s ease, box-shadow 0.4s ease, background-color 0.4s ease;
  &:hover {
    top: 4px;
    box-shadow: 0 0 0 1em rgba(0, 0, 0, 0.04), 0 0 0 8px rgba(0, 0, 0, 0.04);
  }
`

export const SizeButton = styled.div`
  background: #fff;
  box-shadow: 0 0 32px rgba(0, 0, 0, 0.1);
  right: 0;
  color: ${(props: ITheme) => props.theme.colors.palette.emerald};
  position: absolute;
  background: rgba(0, 0, 0, 0.03);
  width: 32px;
  height: 32px;
  bottom: 0;
  text-align: center;
  line-height: 38px;
  font-size: 1em;
  margin: 8px;
  border-radius: 4px;
  svg {
    stroke-width: 3;
  }
  transition: all 0.2s ease;

  &:hover {
    background: #fff;
    box-shadow: 0 0 32px rgba(0, 0, 0, 0.1);
    transform: scale(1.3);
    transform-origin: right bottom;
  }
`

export const IconButton = styled.a<IIconButtonProps>`
  position: absolute;
  z-index: 150;
  top: 5px;
  text-align: center;
  vertical-align: middle;
  line-height: 60px;
  height: 100%;
  width: 25%;
  font-size: 0.875em;
  cursor: pointer;
  background-size: 1.5em 1.5em;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0;

  ${is('left')`
    left: 0;
  `}
  ${is('right')`
    right: 0;
  `}
`

export interface IIconButtonProps {
  right?: boolean
  left?: boolean
  show?: boolean
  expand?: boolean
}

export interface IDayProps {
  selected?: boolean
  inactive?: boolean
  sized?: boolean
  weekend?: boolean
  isSelected?: boolean
}
